import { BaseMutations } from '@/store/base-mutations';
import NewsState from './state';
import { News, NewsFilters } from '../types';
import { default_news } from '../service';

export default class NewsMutations extends BaseMutations<NewsState> {
  SET_NEWS(news: News.News[]) {
    this.state.news = news;
  }

  SET_DETAIL_NEWS(items: News.News) {
    this.state.news_detail = items;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof NewsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  TOGGLE_NEWS_LOADING(toggle: boolean) {
    this.state.news_loading = toggle;
  }

  CLEAR_NEWS_DETAIL() {
    this.state.news_detail = default_news();
  }

  SET_TYPE_STATS(value: string) {
    this.state.type_stats = value;
  }
}
